import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DetailsComponent } from './details.component';
import { TeamsFlowsComponent } from './teams.flows.component';
import { TeamsRequestComponent } from './teams.request.component';
import { ScheduleComponent } from './schedule.component';
import { PermissionComponent } from './permission.component';
import { SharedModule } from "../shared.module"
import { TeamsChartsComponent } from './teams.charts.component';
import { TeamsDashboardComponent } from './teams-dashboard.component';
import { TeamsSettingsComponent } from './teams-settings.component';
import { TeamsComponent } from './teams.component';
import { TeamsOverviewComponent } from './teams-overview.component';
import { TeamsMembersComponent } from './teams-members.component';
import { WorkspaceHubNavComponent } from './workspace-hub-nav.component';
import { WorkspaceIdentityComponent } from './workspace-identity.component';

@NgModule({
  declarations: [
    TeamsComponent,
    DetailsComponent,
    TeamsFlowsComponent,
    ScheduleComponent,
    PermissionComponent,
    TeamsChartsComponent,
    TeamsRequestComponent,
    TeamsDashboardComponent,
    TeamsSettingsComponent,
    TeamsOverviewComponent,
    TeamsMembersComponent,
    WorkspaceHubNavComponent,
    WorkspaceIdentityComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TeamsModule { }
